import React from 'react';
import * as FaIcons from 'react-icons/fa';
// import * as AiFillSetting from 'react-icons/ai';
import * as IoIcons from 'react-icons/io';
import * as  BiAbacus from "react-icons/bi";
// import * as GrAccessibility from "react-icons/gr";
import * as AiOutlineTable from 'react-icons/ai';
import * as AiTwotoneCalendar from 'react-icons/ai';
// import * as GrCheckbox from "react-icons/gr";
import Workspace from './SidebarComp/Workspace';
import YourBoard from './SidebarComp/YourBoard';
import './SidebarComp/Trellosidebar.css';
import Members from './SidebarComp/Members';
import Setting from './SidebarComp/Setting';
import Boardwajahat from './SidebarComp/Boardwajahat';


export const SidebarData = [
    {
        title: 'board',
        path: '/',
        icon: <BiAbacus.BiAbacus />,
        cName: 'nav-text'
    },
    {
        title: <Members/>,
        path: '/reports',
        // icon: <GrAccessibility.GrAccessibility />,
        cName: 'nav-text'
    },
    {
        title: <Setting/>,

        path: '/products',
        // icon: <AiFillSetting.AiFillSetting />,
        cName: 'nav-text'
    },
    {
      title: <Workspace/>

    },
    {
        title: 'Table',
        path: '/team',
        icon: <AiOutlineTable.AiOutlineTable />,
        cName: 'nav-text'
    },
    {
        title: 'Calender',
        path: '/messages',
        icon: <AiTwotoneCalendar.AiTwotoneCalendar />,
        cName: 'nav-text'
    } ,
{
 title: <YourBoard/>
},
      {

        title: <Boardwajahat/>,
        path: '/support',
        // icon: <GrCheckbox.GrCheckbox />,
        cName: 'nav-text'
      }
];
